import React from 'react';

import Loader from './heart-beat.gif';

const searchLoading = () => {
  return (
    <div className="loading"><img src={Loader}></img></div>
  );
};
export default searchLoading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js